import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router';

import type { HierarchyNode } from '@/components/Hco/_hooks/useParentHierarchyNodes';
import { TruncatedText } from '@/components/TruncatedText/TruncatedText';
import { getHcoProfileLink } from '@/utils/hco/getHcoProfileLink';

import { parentHierarchyBreadcrumbStyles as sx } from './ParentHierarchyBreadcrumb.styles';

type SegmentProps = {
	node: HierarchyNode;
};

const BreadcrumbSegment = ({ node }: SegmentProps) => {
	const name = node.hco.hcoNameCda_V ?? '';
	const [naturalWidth, setNaturalWidth] = useState<number | null>(null);

	return (
		<Box sx={sx.item(naturalWidth)}>
			<Link
				component={RouterLink}
				to={getHcoProfileLink(node.hco)}
				underline='none'
				sx={sx.link}
			>
				<TruncatedText
					text={name}
					variant='middle'
					onNaturalWidthChange={setNaturalWidth}
				/>
			</Link>
		</Box>
	);
};

type Props = {
	nodes: HierarchyNode[];
};

export const ParentHierarchyBreadcrumb = ({ nodes }: Props) => {
	const { t } = useTranslation();

	if (nodes.length === 0) return null;

	return (
		<Box component='nav' aria-label={t('Parent Hierarchy')} sx={sx.root}>
			{nodes.map((node, index) => (
				<Fragment key={node.hco.vid_V}>
					{index > 0 && <ChevronRightIcon fontSize='small' sx={sx.separator} />}
					<BreadcrumbSegment node={node} />
				</Fragment>
			))}
		</Box>
	);
};
